import PropTypes from 'prop-types';
export const contentV1PropTypes = {
  description: PropTypes.string
};